/*
 * Always-visible scroll indicator for horizontal lists on TOUCH devices.
 *
 * iPhone Safari (and Android Chrome) draw scrollbars as overlay bars that fade out, and cannot be
 * forced to stay visible, so we draw our own: a thin track under the list with a green thumb that
 * follows the scroll position. The thumb can be dragged, and tapping the track jumps there.
 *
 * Only shown when the primary input is touch ((hover: none) and (pointer: coarse), see
 * gbg-build-finder.css). It never touches the list's own scrolling, so mouse wheel / trackpad
 * scrolling on desktop is unaffected.
 *
 * Attach to a list with [data-gbgb-cases] (the Step 2 case picker) or any [data-gbg-scroll-indicator].
 */
(function () {
  'use strict';

  var MIN_THUMB = 56; // px: stays easy to see even when the list has 50+ items

  function build(list) {
    if (list.__gbgScrollIndicator) return;
    list.__gbgScrollIndicator = true;

    var track = document.createElement('div');
    track.className = 'gbg-scrollbar';
    track.setAttribute('aria-hidden', 'true');
    track.hidden = true;
    var thumb = document.createElement('div');
    thumb.className = 'gbg-scrollbar__thumb';
    track.appendChild(thumb);
    list.insertAdjacentElement('afterend', track);

    function metrics() {
      var max = list.scrollWidth - list.clientWidth;
      var trackW = track.clientWidth;
      var thumbW = Math.min(trackW, Math.max(MIN_THUMB, trackW * (list.clientWidth / list.scrollWidth)));
      return { max: max, trackW: trackW, thumbW: thumbW, free: trackW - thumbW };
    }

    function update() {
      var m = metrics();
      if (m.max <= 1) { track.hidden = true; return; }
      track.hidden = false;
      m = metrics();
      thumb.style.width = m.thumbW + 'px';
      var x = m.free * Math.min(1, Math.max(0, list.scrollLeft / m.max));
      thumb.style.transform = 'translateX(' + x + 'px)';
    }

    list.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    window.addEventListener('orientationchange', update);
    if (window.ResizeObserver) new ResizeObserver(update).observe(list);
    if (window.MutationObserver) new MutationObserver(update).observe(list, { childList: true });
    window.addEventListener('load', update);

    // Drag the thumb / tap the track.
    var drag = null;
    thumb.addEventListener('pointerdown', function (e) {
      var m = metrics();
      if (m.max <= 1 || m.free <= 0) return;
      drag = { x: e.clientX, left: list.scrollLeft, ratio: m.max / m.free };
      thumb.setPointerCapture(e.pointerId);
      e.preventDefault();
    });
    thumb.addEventListener('pointermove', function (e) {
      if (!drag) return;
      list.scrollLeft = drag.left + (e.clientX - drag.x) * drag.ratio;
    });
    function endDrag() { drag = null; }
    thumb.addEventListener('pointerup', endDrag);
    thumb.addEventListener('pointercancel', endDrag);
    track.addEventListener('pointerdown', function (e) {
      if (e.target === thumb) return;
      var m = metrics();
      if (m.max <= 1 || m.free <= 0) return;
      var rect = track.getBoundingClientRect();
      var frac = (e.clientX - rect.left - m.thumbW / 2) / m.free;
      list.scrollTo({ left: Math.min(1, Math.max(0, frac)) * m.max, behavior: 'smooth' });
    });

    update();
  }

  function init() {
    document.querySelectorAll('[data-gbgb-cases], [data-gbg-scroll-indicator]').forEach(build);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
